import React from 'react';
import './App.css';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
  useNavigate
} from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import LandingPage from './LandingPage';
import SignUpPage from './SignUpPage';
import HomePage from './HomePage';
import GameDetailPage from './GameDetailPage';
import VerifyEmailPage from './VerifyEmailPage';
import ProfilePage from './ProfilePage';
import MyBetsPage from './MyBetsPage';
import CurrentBetPage from './CurrentBetPage';
import SportsPage from './SportsPage';
import SportsDetailPage from './SportsDetailPage';

// Component to handle trailing slash normalization
function TrailingSlashNormalizer({ children }) {
  const location = useLocation();
  const navigate = useNavigate();

  React.useEffect(() => {
    // Check if the pathname ends with a slash and it's not the root path
    if (location.pathname !== '/' && location.pathname.endsWith('/')) {
      // Remove the trailing slash and navigate to the normalized path
      const normalizedPath = location.pathname.slice(0, -1);
      
      // Only navigate if we're not already navigating to prevent infinite loops
      const currentPath = location.pathname + location.search + location.hash;
      const targetPath = normalizedPath + location.search + location.hash;
      
      if (currentPath !== targetPath) {
        navigate(targetPath, { replace: true });
      }
    }
  }, [location.pathname, location.search, location.hash, navigate]);

  return children;
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <TrailingSlashNormalizer>
          <div style={{ minHeight: '100vh' }}>
            <Routes>
              <Route path="/" element={<Navigate to="/login" replace />} />
              <Route path="/login/*" element={<LandingPage />} />
              <Route path="/home/*" element={<HomePage />} />
              <Route path="/game/:gameId/*" element={<GameDetailPage />} />
              <Route path="/signup/*" element={<SignUpPage />} />
              <Route path="/verify-email/*" element={<VerifyEmailPage />} />
              <Route path="/profile/*" element={<ProfilePage />} />
              <Route path="/my-bets/*" element={<MyBetsPage />} />
              <Route path="/current_bet/:betId/*" element={<CurrentBetPage />} />
              <Route path="/sports/*" element={<SportsPage />} />
              <Route path="/sports/:sport/*" element={<SportsDetailPage />} />
              <Route path="*" element={<Navigate to="/login" replace />} />
            </Routes>
          </div>
        </TrailingSlashNormalizer>
      </Router>
    </AuthProvider>
  );
}

export default App;
